
































import { Component, Vue } from 'vue-property-decorator'
import { RouteRecord, Route } from 'vue-router'
import { AppModule } from '@/app/store/modules/app'
import Hamburger from '@/app/ui/components/hamburger/index.vue'
import { AuthModule } from '@/app/store/modules/auth'
@Component({
  name: 'Navbar',
  components: {
    Hamburger,
  },
})
export default class extends Vue {
  get currentRouteName() {
    if (this.$route.meta !== undefined) {
      return this.$route.meta.title
    }
    return ''
  }
  get sidebar() {
    return AppModule.sidebar
  }
  get device() {
    return AppModule.device.toString()
  }
  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    await AuthModule.logOut()
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }
}
